import React from "react";

const Section10Limitations = () => (
  <>
    <h2>10. Data Security</h2>
    <p>
    TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL COMPAREDLY LTD., ITS AFFILIATES, DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, SUPPLIERS, OR LICENSORS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES) ARISING OUT OF OR RELATING TO YOUR ACCESS TO OR USE OF, OR YOUR INABILITY TO ACCESS OR USE, THE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT COMPAREDLY LTD. HAS BEEN INFORMED OF THE POSSIBILITY OF SUCH DAMAGE.
    </p>

    <p>
    IN ANY CASE, THE AGGREGATE LIABILITY OF COMPAREDLY LTD. TO YOU FOR ALL CLAIMS ARISING OUT OF OR RELATING TO THE SERVICE SHALL NOT EXCEED THE AMOUNT YOU PAID TO COMPAREDLY LTD. DURING THE TWELVE (12) MONTHS PRIOR TO THE EVENT GIVING RISE TO THE LIABILITY. THE LIMITATIONS OF THIS SECTION SHALL APPLY EVEN IF ANY REMEDY SPECIFIED IN THESE TERMS IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.
    </p>

    <p>
    FOR FREE TRIALS AND BETA SERVICES, THE LIABILITY OF COMPAREDLY LTD. SHALL BE LIMITED TO £10.
    </p>

  </>
);

export default Section10Limitations;
